define(["jquery"], function ($) {
    var searchPage = {
        InitSpellcheck: function () {
            var query = $("#query").val();
            if (query != "") {
                $.get("/find_v2/_spellcheck?query=" + query + "&size=1", function (data) {
                    $.each(data.hits, function (index, value) {
                        $("#spellcheck").append("<p>" + "Menade du: <a href=/Sok/?query=" + encodeURIComponent(value.suggestion) + ">" + value.suggestion + "</a></p>");
                    });
                }, "json");
            }
        },
        TrackResultSearchKeyWords: function (searchCount) { 
            // Matomo will then track for the site search query, the number of results, and will report all keywords with “zero” results in the “No Result Keywords” report.

            // even if matomo analytics is not loaded yet, it will handle thease commands once it is loaded.
            var _paq = window._paq = window._paq || [];

            // sets tracking results by search keywords
            _paq.push(['setCustomUrl', document.URL + '&search_count=' + searchCount]);
            _paq.push(['trackPageView']);
        }
    }
    return searchPage;

});